import {
  ContextualMenu,
  IconPencil,
  IconTrash,
  OptionInterface,
  OptionValue,
  SelectOption,
  TableColumns,
  TableColumnWidth,
  TableData,
  TextBox,
} from '@veneer/core'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import dataListService from '../../services/generalApi/dataList.service'
import { ICountryDto } from '../../models/dto/generalApi/ICountryDto'
import {
  BrandGroup,
  FlatTableRow,
  IBrandNewDto,
  IOptionsBrands,
  IValidationBrands,
  SelectValue,
  IBrandByPosIn,
  ModalMode,
  IModalMessage,
  IBrandBySubRetailIn,
  BrandData,
  IBrandByCountryIn,
} from '../../models/dto/surveyApi/IBrandsDto'
import { ISubretailDto } from '../../models/dto/agendaApi/ISubretailDto'
import { IPointOfSaleByListDto } from '../../models/dto/agendaApi/IPointOfSaleDto'
import appointmentService from '../../services/agendaApi/appointment.service'
import { RootState } from '../../app/store'
import { useSelector } from 'react-redux'
import brandsNewService from '../../services/surveyApi/brandsNew.service'

export const UseBrandsPointOfSale = (
  setOptionSelect: React.Dispatch<React.SetStateAction<IOptionsBrands>>,
  setHandleValidate: React.Dispatch<React.SetStateAction<IValidationBrands>>,
) => {
  const languageID: any = useSelector((state: RootState) => state.languageId)
  const [originalData, setOriginalData] = useState<TableData[]>([])
  const [searchBrands, setSearchBrands] = useState<string>('')
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [loading, setLoading] = useState(false)
  const [isLoadingAction, setIsLoadingAction] = useState(false)
  const [isLoadingBrands, setIsLoadingBrands] = useState(false)
  const [debouncedSearchBrands, setDebouncedSearchBrands] = useState<string>(searchBrands)
  const [t] = useTranslation('global')
  const [dataFromBrands, setDataFromBrands] = useState<IBrandNewDto[]>([])
  //Options Select
  const [brands, setBrands] = useState<NumberOption[]>([])
  const [categories, setCategories] = useState<NumberOption[]>([])
  const [subCategories, setSubCategories] = useState<NumberOption[]>([])
  //Value Select
  const [selectedBrand, setSelectedBrand] = useState<number[]>([])
  const [selectedCategory, setSelectedCategory] = useState<number[]>([])
  const [selectedSubCategory, setSelectedSubCategory] = useState<number[]>([])

  const [subCategoriesByCategory, setSubCategoriesByCategory] = useState<
    Record<number, { value: number; label: string }[]>
  >({})
  const [finalJsonPos, setFinalJsonPos] = useState<IBrandByPosIn[] | null>(null)
  const [finalJsonSubRetail, setFinalJsonSubRetail] = useState<IBrandBySubRetailIn[] | null>(null)
  const [finalJsonCountry, setFinalJsonCountry] = useState<IBrandByCountryIn[] | null>(null)

  const [messageError, setMessageError] = useState<string>('')
  const [messageAction, setMessageAction] = useState<string>('')
  const [openModalCreate, setOpenModalCreate] = useState(false)
  const [disabledSubCategories, setDisabledSubCategories] = useState<boolean>(true)
  const [disabledButtonSend, setDisabledButtonSend] = useState<boolean>(true)
  const [deleteModal, setDeleteModal] = useState<boolean>(false)
  const [modalMessage, setModalMessage] = useState<IModalMessage>({
    show: false,
    title: '',
    description: '',
  })
  const [selectedCountry, setSelectedCountry] = useState<number>()
  const [selectedSubRetail, setSelectedSubRetail] = useState<number>()
  const [selectedPointOfSale, setSelectedPointOfSale] = useState<number | string>()
  const selectCountry = useRef<number | null>(null)
  const selectSubRetail = useRef<number | null>(null)
  const selectPost = useRef<string | null>(null)
  const [modalMode, setModalMode] = useState<ModalMode>('create')
  const [pendingUpdateCategories, setPendingUpdateCategories] = useState<{
    categoryIds: number[]
    subCategoryIds: number[]
  } | null>(null)
  const [categoriesByBrand, setCategoriesByBrand] = useState<Record<number, NumberOption[]>>({})

  const optionsCountryCopy = useRef<SelectOption[]>([])
  const optionsSubRetailCopy = useRef<SelectOption[]>([])
  const optionsPointOfSaleCopy = useRef<SelectOption[]>([])

  useEffect(() => {
    validateBrandRequest(finalJsonPos, finalJsonSubRetail, finalJsonCountry)
  }, [finalJsonPos, finalJsonSubRetail, finalJsonCountry])

  useEffect(() => {
    getCountry()
  }, [])

  useEffect(() => {
    if (modalMode !== 'update' || !pendingUpdateCategories || !subCategoriesByCategory) {
      return
    }

    const { categoryIds, subCategoryIds } = pendingUpdateCategories

    const allSubs = categoryIds.flatMap((catId) => subCategoriesByCategory[catId] ?? [])

    const uniqueSubs = Array.from(new Map(allSubs.map((s) => [s.value, s])).values())

    setSubCategories(uniqueSubs)
    setSelectedSubCategory(subCategoryIds)
  }, [subCategoriesByCategory, modalMode, pendingUpdateCategories])

  const categoryToSubMap = useMemo(() => {
    const map: Record<number, number[]> = {}

    dataFromBrands.forEach((item) => {
      if (!map[item.categoryID]) {
        map[item.categoryID] = []
      }
      map[item.categoryID].push(Number(item.subCategoryID))
    })

    return map
  }, [dataFromBrands])

  useEffect(() => {
    // Si no hay absolutamente nada seleccionado
    if (
      selectedBrand.length === 0 &&
      selectedCategory.length === 0 &&
      selectedSubCategory.length === 0
    ) {
      setFinalJsonPos(null)
      setFinalJsonSubRetail(null)
      setFinalJsonCountry(null)
      return
    }

    const categories =
      selectedCategory.length > 0
        ? selectedCategory.map((catId) => {
            const subsFromCategory = categoryToSubMap[catId] ?? []
            const subsSelectedForThisCat = selectedSubCategory.filter((sub) =>
              subsFromCategory.includes(sub),
            )

            return {
              categoryID: catId,
              subCategories: subsSelectedForThisCat,
            }
          })
        : []

    const brandsToBuild = selectedBrand.length > 0 ? selectedBrand : [null]

    if (selectedPointOfSale) {
      const finalJsonPos: IBrandByPosIn[] = brandsToBuild.map((brandId) => ({
        brandID: brandId,
        posCode: String(selectedPointOfSale),
        categories,
      }))

      setFinalJsonPos(finalJsonPos)
    } else if (selectedSubRetail) {
      const finalJsonSubRetail: IBrandBySubRetailIn[] = brandsToBuild.map((brandId) => ({
        brandID: brandId,
        subRetailID: selectedSubRetail,
        categories,
      }))

      setFinalJsonSubRetail(finalJsonSubRetail)
    } else {
      const finalJsonCountry: IBrandByCountryIn[] = brandsToBuild.map((brandId) => ({
        brandID: brandId,
        countryID: selectedCountry,
        categories,
      }))

      setFinalJsonCountry(finalJsonCountry)
    }
  }, [selectedBrand, selectedCategory, selectedSubCategory, categoryToSubMap, selectedPointOfSale])

  const showError = () => {
    setModalMessage((prev) => ({
      ...prev,
      show: true,
      title: t('header.error'),
      description: t('modal.generalError'),
      secondaryLabel: t('header.closebutton'),
      primaryLabel: undefined,
      onPrimary: undefined,
    }))
  }

  const isPOS = (item: BrandData): item is IBrandByPosIn => 'posCode' in item

  const isSubRetail = (item: BrandData): item is IBrandBySubRetailIn => 'subRetailID' in item

  const isCountry = (item: BrandData): item is IBrandByCountryIn => 'countryID' in item

  const getCountry = async () => {
    try {
      const r = await dataListService.getCountryListBySubregion()
      fillDataCountries(r)
    } catch (error) {
      showError()
    }
  }

  const fillDataCountries = (data: ICountryDto[]) => {
    const countriesData: SelectOption[] = []
    for (let i = 0; i < data.length; i++) {
      const country: ICountryDto = data[i]
      let selectCountryData: SelectOption
      selectCountryData = {
        value: country.contryId,
        label: country.countryName,
      }
      countriesData.push(selectCountryData)
    }
    optionsCountryCopy.current = countriesData
    setOptionSelect((prev) => ({
      ...prev,
      Country: countriesData,
    }))
  }

  const getSubretails = async (countrySelected: SelectValue) => {
    try {
      const r = await dataListService.getSubretailListByCountry(Number(countrySelected))
      if (r.length > 0) {
        fillDataSubretail(r)
      } else {
        showError()
        return
      }
    } catch (error) {
      showError()
    }
  }

  const fillDataSubretail = (data: ISubretailDto[]) => {
    const subretailData: SelectOption[] = []
    for (let i = 0; i < data.length; i++) {
      const subretail: ISubretailDto = data[i]
      let selectedSubretailData: SelectOption
      selectedSubretailData = {
        value: subretail.fieldID,
        label: subretail.fieldValue,
      }
      subretailData.push(selectedSubretailData)
    }
    optionsSubRetailCopy.current = subretailData
    setOptionSelect((prev) => ({
      ...prev,
      SubRetail: subretailData,
    }))
  }

  const getPointOfSales = async (subretailId: SelectValue) => {
    try {
      const r = await appointmentService.getPosListBySubretailList(String(subretailId))

      if (r.length > 0) {
        fillDataPointOfSale(r)
      } else {
        showError()
        return
      }
    } catch (error) {
      showError()
    }
  }

  const fillDataPointOfSale = (data: IPointOfSaleByListDto[]) => {
    const pointOfsaleData: SelectOption[] = []
    for (let i = 0; i < data.length; i++) {
      const pointOfsale: IPointOfSaleByListDto = data[i]
      let selectePointOfSaleData: SelectOption
      if (pointOfsale.fieldID) {
        selectePointOfSaleData = {
          value: pointOfsale.fieldID,
          label: pointOfsale.fieldValue,
        }
        pointOfsaleData.push(selectePointOfSaleData)
      }
    }
    optionsPointOfSaleCopy.current = pointOfsaleData
    setOptionSelect((prev) => ({
      ...prev,
      PointOfSale: pointOfsaleData,
    }))
  }

  const getBrandsData = async (selected: SelectValue, nameSelected: string) => {
    setLoading(true)
    try {
      if (nameSelected === 'Country') {
        const r = await brandsNewService.getBrandsByCountry(Number(selected), languageID.value)

        if (String(selected).length > 0) {
          fillDataBrands(r)
        }
      } else if (nameSelected === 'SubRetail') {
        const r = await brandsNewService.getBrandsBySubretail(Number(selected), languageID.value)

        if (String(selected).length > 0) {
          fillDataBrands(r)
        }
      } else if (nameSelected === 'PointOfSale') {
        const r = await brandsNewService.getBrandsByPos(String(selected), languageID.value)

        if (String(selected).length > 0) {
          fillDataBrands(r)
        }
      }
    } catch (error) {
      showError()
    } finally {
      setLoading(false)
    }
  }

  const fillDataBrands = (data: IBrandNewDto[]) => {
    const grouped: Record<number, BrandGroup> = {}

    data.forEach((item) => {
      const { brandID, categoryID, subCategoryID } = item

      if (!grouped[brandID]) {
        grouped[brandID] = {
          brandID: brandID,
          brandName: item.brandName,
          categories: {},
        }
      }

      if (!grouped[brandID].categories[categoryID]) {
        grouped[brandID].categories[categoryID] = {
          categoryID,
          categoryName: item.categoryName,
          subCategories: [],
        }
      }

      if (subCategoryID) {
        grouped[brandID].categories[categoryID].subCategories.push({
          subCategoryID,
          subCategoryName: item.subCategoryName ?? '',
        })
      }
    })

    const flatTableRows: FlatTableRow[] = []

    Object.values(grouped).forEach((brand) => {
      const categoriesArray = Object.values(brand.categories)

      const categoriesText = categoriesArray.map((c) => c.categoryName).join(', ')

      const subCategoriesText = categoriesArray
        .flatMap((c) => c.subCategories.map((sc) => sc.subCategoryName))
        .join(', ')

      const categoriesForUpdate = categoriesArray.map((c) => ({
        categoryID: c.categoryID,
        subCategories: c.subCategories.map((sc) => sc.subCategoryID),
      }))

      flatTableRows.push({
        brandID: brand.brandID,
        brands: brand.brandName,
        categories: categoriesText,
        subCategories: subCategoriesText,
        rowConfig: {
          action: contextualMenu(brand.brandID, categoriesForUpdate),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      })
    })
    setCurrentPage(1)
    setOriginalData(flatTableRows)
    setLoading(false)
  }

  const getBrands = async () => {
    setIsLoadingBrands(true)
    try {
      const r = await brandsNewService.getBrands(languageID.value)
      setDataFromBrands(r)
      const result = normalizeBrandData(r)
      const existingBrandIds = originalData.map((item) => item.brandID)

      // Filtrar marcas para el select
      const filteredBrands = result.brands.filter(
        (brand) => !existingBrandIds.includes(brand.value),
      )

      return filteredBrands.length > 0
    } catch (e) {
      showError()
      return false
    } finally {
      setIsLoadingBrands(false)
    }
  }

  function normalizeBrandData(data: IBrandNewDto[]): {
    brands: NumberOption[]
    categories: NumberOption[]
    categoriesByBrand: Record<number, NumberOption[]>
    subCategoriesByCategory: Record<number, NumberOption[]>
  } {
    const brandsMap = new Map<number, string>()
    const categoriesMap = new Map<number, string>()
    const categoriesByBrandMap: Record<number, Map<number, string>> = {}
    const subCatsByCat: Record<number, Map<number, string>> = {}

    data.forEach((item) => {
      const brandId = Number(item.brandID)
      const categoryId = Number(item.categoryID)
      const subCategoryId = Number(item.subCategoryID)

      // ✅ LIMPIAR brandName
      const brandName = item.brandName?.trim()
      if (brandName) {
        brandsMap.set(brandId, brandName)
      }

      // ✅ LIMPIAR categoryName
      const categoryName = item.categoryName?.trim()
      if (categoryName) {
        categoriesMap.set(categoryId, categoryName)

        if (!categoriesByBrandMap[brandId]) {
          categoriesByBrandMap[brandId] = new Map<number, string>()
        }
        categoriesByBrandMap[brandId].set(categoryId, categoryName)
      }

      // ✅ LIMPIAR subCategoryName
      const subCategoryName = item.subCategoryName?.trim()
      if (subCategoryName) {
        if (!subCatsByCat[categoryId]) {
          subCatsByCat[categoryId] = new Map<number, string>()
        }
        subCatsByCat[categoryId].set(subCategoryId, subCategoryName)
      }
    })

    const categoriesByBrand: Record<number, NumberOption[]> = {}
    Object.entries(categoriesByBrandMap).forEach(([brandId, catMap]) => {
      categoriesByBrand[Number(brandId)] = Array.from(catMap, ([value, label]) => ({
        value,
        label,
      }))
    })

    const subCategoriesByCategory: Record<number, NumberOption[]> = {}
    Object.entries(subCatsByCat).forEach(([catId, subMap]) => {
      subCategoriesByCategory[Number(catId)] = Array.from(subMap, ([value, label]) => ({
        value,
        label,
      }))
    })

    return {
      brands: Array.from(brandsMap, ([value, label]) => ({ value, label })),
      categories: Array.from(categoriesMap, ([value, label]) => ({
        value,
        label,
      })),
      categoriesByBrand,
      subCategoriesByCategory,
    }
  }

  useEffect(() => {
    const result = normalizeBrandData(dataFromBrands)

    // IDs de marcas que ya existen
    const existingBrandIds = originalData.map((item) => item.brandID)

    // Filtrar marcas para el select
    const filteredBrands = result.brands.filter((brand) => !existingBrandIds.includes(brand.value))

    if (modalMode !== 'update') {
      setBrands(filteredBrands)
      setCategories([])
      setSubCategories([])
    } else {
      setBrands(result.brands)
      setCategories(result.categories)
    }
    setCategoriesByBrand(result.categoriesByBrand)
    setSubCategoriesByCategory(result.subCategoriesByCategory)
  }, [dataFromBrands, originalData, modalMode])

  const onChangeSelect = (value: SelectValue, name: string) => {
    if (name === 'Country') {
      setSelectedCountry(Number(value))
      selectCountry.current = Number(value)
      getBrandsData(value, name)
      getSubretails(value)
      setSelectedPointOfSale(undefined)
      setSelectedSubRetail(undefined)
      selectSubRetail.current = null
      selectPost.current = null
      setOptionSelect((prev) => ({
        ...prev,
        SubRetail: [],
        PointOfSale: [],
      }))
    } else if (name === 'SubRetail') {
      setSelectedSubRetail(Number(value))
      selectSubRetail.current = Number(value)
      getBrandsData(value, name)
      getPointOfSales(value)
      setSelectedPointOfSale(undefined)
      selectPost.current = null
      setOptionSelect((prev) => ({
        ...prev,
        PointOfSale: [],
      }))
    } else {
      setSelectedPointOfSale(String(value))
      selectPost.current = String(value)
      getBrandsData(value, name)
    }
    setHandleValidate((prev) => ({
      ...prev,
      [name]: false,
    }))
  }

  const onClickOpenButtonAddBrand = async () => {
    onClose()
    setModalMode('create')
    const hasAvailableBrands = await getBrands()

    if (!hasAvailableBrands) {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.noBrands'),
        description: t('brands.noBrandsReason'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: undefined,
        onPrimary: undefined,
      }))
      return
    }
    if (selectedCountry && !selectedSubRetail && !selectedPointOfSale) {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.createBrandCountry'),
        description: t('brands.countryBrandScope'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: t('header.next'),
        onPrimary: () => addBrand(),
      }))
    } else if (selectedCountry && selectedSubRetail && !selectedPointOfSale) {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.createBrandSubRetail'),
        description: t('brands.subRetailBrandScope'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: t('header.next'),
        onPrimary: () => addBrand(),
      }))
    } else {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.createBrandPos'),
        description: t('brands.posBrandScope'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: t('header.next'),
        onPrimary: () => addBrand(),
      }))
    }
  }

  const openModalUpdateBrand = () => {
    const country = selectCountry.current
    const subRetail = selectSubRetail.current
    const pos = selectPost.current

    if (country && !subRetail && !pos) {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.updateBrandCountry'),
        description: t('brands.countryBrandUpdateScope'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: t('header.next'),
        onPrimary: () => {
          closeModal()
          setOpenModalCreate(true)
        },
      }))
    } else if (country && subRetail && !pos) {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.updateBrandSubRetail'),
        description: t('brands.subRetailBrandUpdateScope'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: t('header.next'),
        onPrimary: () => {
          closeModal()
          setOpenModalCreate(true)
        },
      }))
    } else {
      setModalMessage((prev) => ({
        ...prev,
        show: true,
        title: t('brands.updateBrandPos'),
        description: t('brands.posBrandUpdateScope'),
        secondaryLabel: t('header.closebutton'),
        primaryLabel: t('header.next'),
        onPrimary: () => {
          closeModal()
          setOpenModalCreate(true)
        },
      }))
    }
  }

  const onChangeBrand = (option: SelectOption<number> | null) => {
    const value = option?.value

    if (value === undefined) return

    setSelectedBrand((prevBrands) => {
      const updatedBrands = [value]

      // 1️⃣ Categorías permitidas según marcas finales
      const allCategories = updatedBrands.flatMap((brandId) => categoriesByBrand[brandId] ?? [])

      // 2️⃣ Quitar duplicados
      const uniqueCategories = Array.from(new Map(allCategories.map((c) => [c.value, c])).values())

      setCategories(uniqueCategories)

      // 3️⃣ Mantener SOLO categorías válidas
      const validCategoryIds = new Set(uniqueCategories.map((c) => c.value))

      setSelectedCategory((prevCategories) =>
        prevCategories.filter((catId) => validCategoryIds.has(catId)),
      )

      // 4️⃣ Subcategorías válidas según categorías finales
      const validSubCategories = Array.from(
        new Map(
          Array.from(validCategoryIds)
            .flatMap((catId) => subCategoriesByCategory[catId] ?? [])
            .map((s) => [s.value, s]),
        ).values(),
      )

      setSubCategories(validSubCategories)

      // 5️⃣ Mantener SOLO subcategorías válidas
      const validSubIds = new Set(validSubCategories.map((s) => s.value))

      setSelectedSubCategory((prevSubs) => prevSubs.filter((subId) => validSubIds.has(subId)))

      return updatedBrands
    })
  }

  const onChangeCategory = (option: SelectOption<number> | null) => {
    const value = option?.value

    if (value === undefined) {
      setSelectedCategory([])
      setSelectedSubCategory([])
      setSubCategories([])
      return
    }

    setSelectedCategory((prevCategories) => {
      const exists = prevCategories.includes(value)

      const updatedCategories = exists
        ? prevCategories.filter((v) => v !== value)
        : [...prevCategories, value]

      // 1️⃣ Subcategorías permitidas según categorías finales
      const allSubs = updatedCategories.flatMap((catId) => subCategoriesByCategory[catId] ?? [])

      // 2️⃣ Quitar duplicados
      const uniqueSubs = Array.from(new Map(allSubs.map((s) => [s.value, s])).values())

      setSubCategories(uniqueSubs)

      // 3️⃣ Mantener SOLO subcategorías válidas
      const validSubIds = new Set(uniqueSubs.map((s) => s.value))

      setSelectedSubCategory((prevSubs) => prevSubs.filter((subId) => validSubIds.has(subId)))

      return updatedCategories
    })
  }

  const onChangeSubCategory = (option: SelectOption<number> | null) => {
    const value = option?.value

    if (value === undefined) {
      // Se limpió todo desde el select
      setSelectedSubCategory([])
      return
    }

    setSelectedSubCategory((prev) => {
      if (!prev) return [value]

      const exists = prev.includes(value)

      return exists
        ? prev.filter((v) => v !== value) // quitar
        : [...prev, value] // agregar
    })
  }

  const validateBrandRequest = (
    posData: IBrandByPosIn[] | null,
    subRetailData: IBrandBySubRetailIn[] | null,
    countryData: IBrandByCountryIn[] | null,
  ): boolean => {
    // Si hay POS → validamos POS
    if (posData && posData.length > 0) {
      return validateSingleBrand(posData)
    }

    // Si no hay POS pero hay SubRetail → validamos SubRetail
    if (subRetailData && subRetailData.length > 0) {
      return validateSingleBrand(subRetailData)
    }

    if (countryData && countryData.length > 0) {
      return validateSingleBrand(countryData)
    }

    setDisabledSubCategories(true)
    setDisabledButtonSend(true)
    return false
  }

  const validateSingleBrand = (data: BrandData[]): boolean => {
    for (const item of data) {
      const hasBrand = item.brandID !== null && item.brandID !== undefined
      const hasCategories = item.categories && item.categories.length > 0

      if (!hasBrand && !hasCategories) {
        setMessageError(t('brands.selectOneBrandOrCategory'))
        setDisabledSubCategories(true)
        setDisabledButtonSend(true)
        return false
      }

      if (!hasBrand) {
        setMessageError(t('brands.selectBrandRequired'))
        setDisabledButtonSend(true)
        return false
      }

      if (hasCategories) setDisabledSubCategories(false)

      if (hasBrand && !hasCategories) {
        setMessageError(t('brands.selectAtLeastOneCategory'))
        setDisabledSubCategories(true)
        setDisabledButtonSend(true)
        return false
      }

      // Validación de categorías y subcategorías (igual que antes)
      if (hasCategories) {
        for (const cat of item.categories) {
          const categoryInfo = dataFromBrands.find((c) => c.categoryID === cat.categoryID)

          const categoryName = categoryInfo?.categoryName ?? `CategoryID ${cat.categoryID}`

          if (!cat.subCategories || cat.subCategories.length === 0) {
            setMessageError(
              t('brands.categoryNoSubcategories', {
                categoryName,
                ns: 'global',
              }),
            )
            setDisabledButtonSend(true)
            return false
          }

          for (const sub of cat.subCategories) {
            const subInfo = dataFromBrands.find(
              (s) =>
                s.subCategoryID === sub &&
                s.categoryID === cat.categoryID &&
                (!hasBrand || s.brandID === item.brandID),
            )
            const subName = subInfo?.subCategoryName ?? `SubCategoryID ${sub}`
            if (!sub) {
              setMessageError(
                t('brands.missingSubcategory', {
                  categoryName,
                  subName,
                  ns: 'global',
                }),
              )
              setDisabledButtonSend(true)
              return false
            }
          }
        }
      }

      if (isPOS(item)) {
        if (!item.posCode) {
          setMessageError(t('brands.missingPosCode'))
          setDisabledButtonSend(true)
          return false
        }
      }

      if (isSubRetail(item)) {
        if (!item.subRetailID) {
          setMessageError(t('brands.missingSubRetailId'))
          setDisabledButtonSend(true)
          return false
        }
      }

      if (isCountry(item)) {
        if (!item.countryID) {
          setMessageError(t('brands.missingSubRetailId'))
          setDisabledButtonSend(true)
          return false
        }
      }
    }

    setMessageError('')
    setDisabledButtonSend(false)
    return true
  }

  const onClearModal = (
    setter: React.Dispatch<React.SetStateAction<number[]>>,
    nameOnClear: string,
  ) => {
    if (nameOnClear === 'categories') {
      setSelectedSubCategory([])
    }
    setter([])
  }

  const onClearSelect = (nameOnClear: string) => {
    if (nameOnClear === 'Country') {
      selectCountry.current = null
      selectSubRetail.current = null
      selectPost.current = null
      setSelectedCountry(undefined)
      setSelectedSubRetail(undefined)
      setSelectedPointOfSale(undefined)
      setHandleValidate((prev) => ({
        ...prev,
        [nameOnClear]: true,
        PointOfSale: true,
        SubRetail: true,
      }))
      setOriginalData([])
    }

    if (nameOnClear === 'SubRetail' && selectedCountry) {
      selectSubRetail.current = null
      selectPost.current = null
      setSelectedSubRetail(undefined)
      setSelectedPointOfSale(undefined)
      setHandleValidate((prev) => ({
        ...prev,
        [nameOnClear]: true,
        PointOfSale: true,
      }))
      getBrandsData(selectedCountry, 'Country')
    }

    if (nameOnClear === 'PointOfSale' && selectedSubRetail) {
      selectPost.current = null
      setSelectedPointOfSale(undefined)
      setHandleValidate((prev) => ({
        ...prev,
        [nameOnClear]: true,
      }))
      getBrandsData(selectedSubRetail, 'SubRetail')
    }
  }

  const onClose = () => {
    setOpenModalCreate(false)
    setSelectedBrand([])
    setSelectedCategory([])
    setSelectedSubCategory([])
  }

  const handleChangeSearchBrands = (value: string) => {
    setSearchBrands(value)
    setCurrentPage(1)
  }

  const closeModal = () => {
    setModalMessage((prev) => ({ ...prev, show: false }))
  }

  const openDeleteModal = (brandID: number) => {
    const country = selectCountry.current
    const subRetail = selectSubRetail.current
    const pos = selectPost.current

    if (country && !subRetail && !pos) {
      setModalMessage({
        show: true,
        title: t('brands.countryBrandDelete'),
        description: (
          <>
            <p>{t('brands.countryBrandDeleteScope')}</p>
            <p>{t('brands.confirmAction')}</p>
          </>
        ),
        primaryLabel: t('header.delete'),
        secondaryLabel: t('header.cancel'),
        onPrimary: () => {
          deleteBrand(brandID, 'Country')
        },
      })
    } else if (country && subRetail && !pos) {
      setModalMessage({
        show: true,
        title: t('brands.subRetailBrandDelete'),
        description: (
          <>
            <p>{t('brands.subRetailBrandDeleteScope')}</p>
            <p>{t('brands.confirmAction')}</p>
          </>
        ),
        primaryLabel: t('header.delete'),
        secondaryLabel: t('header.cancel'),
        onPrimary: () => {
          deleteBrand(brandID, 'SubRetail')
        },
      })
    } else {
      setModalMessage({
        show: true,
        title: t('brands.posBrandDelete'),
        description: (
          <>
            <p>{t('brands.posBrandDeleteScope')}</p>
            <p>{t('brands.confirmAction')}</p>
          </>
        ),
        primaryLabel: t('header.delete'),
        secondaryLabel: t('header.cancel'),
        onPrimary: () => {
          deleteBrand(brandID, 'PointOfSale')
        },
      })
    }
  }

  interface NumberOption {
    label: string
    value: number
  }

  const options: OptionInterface[] = [
    { value: 1, label: t('header.delete'), icon: <IconTrash /> },
    { value: 2, label: t('header.update'), icon: <IconPencil /> },
  ]

  const contextualMenu = (
    brandID: number,
    categories: {
      categoryID: number
      subCategories: number[]
    }[],
  ) => (
    <ContextualMenu
      onClick={(e: any, option?: OptionInterface<OptionValue> | undefined) => {
        if (option?.label === t('header.delete')) {
          openDeleteModal(brandID)
        } else if (option?.label === t('header.update')) {
          getBrands()

          setModalMode('update')
          setSelectedBrand([brandID])

          const categoryIds = categories.map((c) => c.categoryID)
          const subCategoryIds = categories.flatMap((c) => c.subCategories)

          setSelectedCategory(categoryIds)

          setPendingUpdateCategories({
            categoryIds,
            subCategoryIds,
          })

          openModalUpdateBrand()
        }
      }}
      options={options}
    />
  )

  const submitNewBrand = async () => {
    // Si es actualización
    if (modalMode !== 'create') {
      updateBrand()
      return
    }
    try {
      if (selectedCountry && !selectedSubRetail && !selectedPointOfSale && finalJsonCountry) {
        setMessageAction(t('brands.savingChangesCountry'))
        setIsLoadingAction(true)
        await brandsNewService.insertBrandByCountry(finalJsonCountry)
        setOpenModalCreate(false)
        getBrandsData(selectedCountry, 'Country')
        return
      }

      if (selectedCountry && selectedSubRetail && !selectedPointOfSale && finalJsonSubRetail) {
        setMessageAction(t('brands.savingChangesSubretail'))
        setIsLoadingAction(true)
        await brandsNewService.insertBrandBySubretail(finalJsonSubRetail)
        setOpenModalCreate(false)
        getBrandsData(selectedSubRetail, 'SubRetail')
        return
      }

      if (selectedCountry && selectedSubRetail && selectedPointOfSale && finalJsonPos) {
        setMessageAction(t('brands.savingChangesPointOfSale'))
        setIsLoadingAction(true)
        await brandsNewService.insertBrandByPos(finalJsonPos)
        setOpenModalCreate(false)
        getBrandsData(selectedPointOfSale, 'PointOfSale')
        return
      }

      showError()
    } catch (error) {
      showError()
    } finally {
      setIsLoadingAction(false)
    }
  }

  const deleteBrand = async (brandIdToDelete: number | null, selectName: String) => {
    const postId = selectPost.current
    const country = selectCountry.current
    const subRetail = selectSubRetail.current

    if (!brandIdToDelete) {
      showError()
      return
    }

    try {
      if (selectName === 'Country' && country) {
        setMessageAction(t('brands.deletingBrandFromCountry'))
        setIsLoadingAction(true)
        await brandsNewService.deleteBrandByCountry(brandIdToDelete, country)
        getBrandsData(country, 'Country')
        closeModal()
        return
      } else if (selectName === 'SubRetail' && subRetail) {
        setMessageAction(t('brands.deletingBrandFromSubretail'))
        setIsLoadingAction(true)
        await brandsNewService.deleteBrandBySubretail(brandIdToDelete, subRetail)
        getBrandsData(subRetail, 'SubRetail')
        closeModal()
        return
      } else {
        if (!postId) {
          closeModal()
          showError()
          return
        }
        setMessageAction(t('brands.deletingBrandFromPointOfSale'))
        setIsLoadingAction(true)
        await brandsNewService.deleteBrandByPos(brandIdToDelete, postId)
        getBrandsData(postId, 'PointOfSale')
        closeModal()
        return
      }
    } catch (error) {
      showError()
      closeModal()
    } finally {
      setIsLoadingAction(false)
    }
  }

  const addBrand = () => {
    setFinalJsonPos(null)
    setFinalJsonSubRetail(null)
    setFinalJsonCountry(null)
    closeModal()
    setOpenModalCreate(true)
  }

  const updateBrand = async () => {
    const postId = selectPost.current
    const country = selectCountry.current
    const subRetail = selectSubRetail.current

    try {
      // ===== POS =====
      if (postId && finalJsonPos) {
        setMessageAction(t('brands.updatingChangesInPointOfSale'))
        setIsLoadingAction(true)
        const r = await brandsNewService.updateBrandByPos(finalJsonPos)

        if (r === 1) {
          getBrandsData(postId, 'PointOfSale')
          onClose()
        }

        return
      }

      // ===== SUBRETAIL =====
      if (!postId && subRetail && country && finalJsonSubRetail) {
        setMessageAction(t('brands.updatingChangesInSubretail'))
        setIsLoadingAction(true)
        const r = await brandsNewService.updateBrandBySubRetail(finalJsonSubRetail)

        if (r === 1) {
          getBrandsData(subRetail, 'SubRetail')
          onClose()
        }

        return
      }

      // ===== COUNTRY =====
      if (!postId && !subRetail && country && finalJsonCountry) {
        setMessageAction(t('brands.updatingChangesInCountry'))
        setIsLoadingAction(true)
        const r = await brandsNewService.updateBrandByCountry(finalJsonCountry)

        if (r === 1) {
          getBrandsData(country, 'Country')
          onClose()
        }

        return
      }

      // ===== INVALID STATE =====
      onClose()
    } catch (error) {
      showError()
      onClose()
    } finally {
      setIsLoadingAction(false)
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchBrands(searchBrands)
    }, 500)
    return () => clearTimeout(handler)
  }, [searchBrands])

  const handleSearch = (query: string, sourceOptions: any[], key: keyof IOptionsBrands) => {
    const filtered = sourceOptions.filter((option) =>
      option.label.toLowerCase().includes(query.toLowerCase()),
    )

    setOptionSelect((prev) => ({
      ...prev,
      [key]: filtered,
    }))
  }

  const searchTextBox = useMemo(
    () => (
      <TextBox
        className="searchUserCheckInVsAbsence"
        id="TextboxUser"
        label={t('header.search')}
        type="search"
        onChange={handleChangeSearchBrands}
        value={searchBrands}
      />
    ),
    [searchBrands, t],
  )

  const columns: TableColumns[] = [
    { id: 'brands', label: t('header.brands'), filter: searchTextBox },
    { id: 'categories', label: t('header.categories') },
    { id: 'subCategories', label: t('header.subcategories') },
  ]

  const columnsWidth: TableColumnWidth[] = [
    { columnId: 'brands' },
    { columnId: 'categories' },
    { columnId: 'subCategories', width: 800 },
  ]

  const tableData = useMemo(() => {
    if (!debouncedSearchBrands) return originalData

    return originalData.filter((element) =>
      element.brands.toLowerCase().includes(debouncedSearchBrands.toLowerCase()),
    )
  }, [debouncedSearchBrands, originalData])

  //cambiar a const despues lo deje let para unas pruebas
  let pagedData = useMemo(() => {
    return tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
  }, [tableData, currentPage, pageSize])

  return {
    tableData,
    columns,
    columnsWidth,
    pagedData,
    currentPage,
    pageSize,
    loading,
    setCurrentPage,
    setPageSize,
    onChangeSelect,
    onClickOpenButtonAddBrand,
    brands,
    onChangeBrand,
    categories,
    onChangeCategory,
    subCategories,
    selectedBrand,
    selectedCategory,
    selectedSubCategory,
    onChangeSubCategory,
    disabledSubCategories,
    setSelectedBrand,
    setSelectedCategory,
    setSelectedSubCategory,
    messageError,
    onClearModal,
    onClose,
    openModalCreate,
    disabledButtonSend,
    submitNewBrand,
    setDeleteModal,
    deleteModal,
    deleteBrand,
    modalMode,
    modalMessage,
    setModalMessage,
    selectedCountry,
    selectedSubRetail,
    selectedPointOfSale,
    closeModal,
    selectCountry,
    selectSubRetail,
    selectPost,
    onClearSelect,
    originalData,
    isLoadingBrands,
    setIsLoadingBrands,
    handleSearch,
    optionsCountryCopy,
    optionsSubRetailCopy,
    optionsPointOfSaleCopy,
    isLoadingAction,
    setIsLoadingAction,
    messageAction,
  }
}
